import React from 'react';
import { Loader } from 'lucide-react';

const Verifying = ({ config }) => (
  <div className={`bg-white text-gray-800 h-full flex flex-col items-center justify-center p-3 ${config.ui.maxWidth} mx-auto`}>
    <Loader className="w-12 h-12 text-blue-600 animate-spin mb-4" />
    <div className="text-lg font-bold text-gray-800 mb-3">Processing Transaction</div>
    <div className="text-sm text-gray-600 mb-6">Please wait while we process your payment...</div>
    <div className="w-48 bg-gray-200 rounded-full h-2 mb-3">
      <div className="bg-blue-600 h-2 rounded-full animate-pulse transition-all duration-1000" style={{width: '70%'}}></div>
    </div>
    <div className="text-xs text-gray-500 animate-pulse">Contacting Bank...</div>
  </div>
);

export default Verifying;